import { api } from "../../../utils/api";

const BASE_URL = "/finance/invoices";

// ✅ Create Invoice (from DC)
export const createInvoiceFromDC = async (data) => {
  const res = await api.post(`${BASE_URL}/from-dc`, data);
  return res.data.data;
};

// ✅ Manual Create Invoice
export const createInvoiceManual = async (data) => {
  const res = await api.post("/finance/invoices", data);
  return res.data.data;
};

// ✅ Get Invoice List (with search + pagination)
export const fetchInvoices = async (params) => {
  const res = await api.get(BASE_URL, { params });
  return {
    data: res.data.data,
    meta: res.data.meta,
  };
};

// ✅ Get Invoice Details
export const fetchInvoiceById = async (id) => {
  const res = await api.get(`${BASE_URL}/${id}`);
  return res.data.data;
};

// ✅ Delete Invoice
export const deleteInvoice = async (id) => {
  const res = await api.delete(`${BASE_URL}/${id}`);
  return res.data;
};